import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ExternalLink, FilePlus2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { HelpLink } from './HelpLink';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const salesQuoteHref = (id) => `/admin?tab=quotes&quote=${id}`;

// Create (once) or open the Sales Quote linked to a configurator quote request.
export const LinkedQuoteAction = ({ request, token, onLinked }) => {
  const [busy, setBusy] = useState(false);
  const lq = request.linked_quote || (request.linked_quote_id && { id: request.linked_quote_id });
  const create = async () => {
    if (!window.confirm(`Create a Sales Quote from ${request.request_number}? This can only be done once.`)) return;
    setBusy(true);
    try {
      const r = await axios.post(`${API_URL}/admin/quote-requests/${request.id}/create-quote`, {}, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Sales Quote created and linked');
      onLinked({ linked_quote_id: r.data.quote_id, linked_quote: { id: r.data.quote_id, status: r.data.status, total: r.data.total }, status: 'quoted' });
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not create the Sales Quote');
    } finally { setBusy(false); }
  };
  if (lq) {
    return (
      <div className="flex flex-wrap items-center justify-between gap-3 p-4 border border-green-200 bg-green-50 rounded-lg" data-testid="linked-quote-panel">
        <div className="text-sm">
          <p className="font-medium text-neutral-900">Linked Sales Quote <span className="font-mono" data-testid="linked-quote-number">#{lq.quote_number || lq.id.slice(0, 8).toUpperCase()}</span></p>
          <p className="text-neutral-600 capitalize" data-testid="linked-quote-status">Status: {(lq.status || 'pending').replace(/_/g, ' ')}{lq.total != null ? ` · $${Number(lq.total).toFixed(2)}` : ''}</p>
        </div>
        <Button asChild size="sm" variant="outline" data-testid="view-sales-quote-btn">
          <a href={salesQuoteHref(lq.id)} target="_blank" rel="noreferrer"><ExternalLink className="w-4 h-4 mr-1.5" />View Sales Quote</a>
        </Button>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 p-4 border border-neutral-200 rounded-lg" data-testid="create-quote-panel">
      <p className="text-sm text-neutral-600">No Sales Quote yet. Creating one copies the customer, products, sizes, notes and source, and links both records. <HelpLink topic="quote-linking" /></p>
      <Button size="sm" onClick={create} disabled={busy} data-testid="create-quote-from-request-btn">
        {busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <FilePlus2 className="w-4 h-4 mr-1.5" />}Create quote from this request
      </Button>
    </div>
  );
};
